import TextReview from "./TextReview";
import TextReviewB from "./TextReviewB";
import TextStar from "./TextStar";
import DotB from "./dotB";
import DotC from "./dotC";
import TextRating from "./textRating";

export default function TextRatingAndReview() {
  return (
    <div className="flex justify-start color222 7:font-semibold   ">
      <TextRating />
      <DotC/>
      <TextReviewB/>
    </div>
  );
}
